import React from 'react';
import MinHeightPage from './MinHeightPage';
import i18n from '../../../common/i18n';

export function RegistrationLoading() {
    return (
        <MinHeightPage>
            <div className="onb-padding onb-loading fs-14">{i18n('nui.registration.common.loading')}</div>
        </MinHeightPage>
    );
}
